module.exports = {"name":"dna-1003-everest-race-profiles"}


//////////////////
// WEBPACK FOOTER
// ./src/content/project.json
// module id = peJn
// module chunks = 0